import React from "react";

import Select from "react-select";
import "react-select/dist/react-select.css";

import "./AxiomSelect.css";

export default class AxiomSelect extends React.Component {
  render() {
    const multiSelect = {};
    if (this.props.multiSelect) multiSelect["multi"] = true;
    const searchable = this.props.hasOwnProperty("searchable") ? this.props.searchable : true;
    return (
      <Select
        className={
          "axiom-select " +
          (this.props.className || "") +
          (this.props.disabled ? " disabled" : " enabled")
        }
        onInputChange={(val) =>
          this.props.onInputChange ? this.props.onInputChange(this.props.name, val) : null
        }
        closeOnSelect={this.props.closeOnSelect}
        clearable={this.props.clearable || false}
        disabled={this.props.disabled}
        onChange={(selectedOption) =>
          this.props.onChange ? this.props.onChange(this.props.name, selectedOption) : null
        }
        options={this.props.options}
        placeholder={this.props.placeholder ? this.props.placeholder : ""}
        removeSelected={this.props.removeSelected}
        rtl={this.props.rtl}
        simpleValue
        value={this.props.value}
        noResultsText={this.props.noResultsText}
        searchPromptText={this.props.searchPromptText}
        searchable={searchable}
        arrowRenderer={this.props.arrowRenderer}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        onInputKeyDown={this.props.onInputKeyDown}
        style={this.props.style || {}}
        menuContainerStyle={this.props.menuContainerStyle || {}}
        {...multiSelect}
      />
    );
  }
}
